export interface NumberOptions {
  readonly minimumFractionDigits?: number;
  readonly maximumFractionDigits?: number;
}

export function formatNumber(value: number, locale: string, opts: NumberOptions = {}): string {
  return new Intl.NumberFormat(locale, opts).format(value);
}

export function formatPercent(fraction: number, locale: string, opts: NumberOptions = {}): string {
  return new Intl.NumberFormat(locale, { style: 'percent', ...opts }).format(fraction);
}

export function formatCompact(value: number, locale: string): string {
  return new Intl.NumberFormat(locale, { notation: 'compact', maximumFractionDigits: 1 }).format(
    value,
  );
}
